import getContentDataSource from '@gameday/core/datasources/helpers/getContentDatasource';

const recapDataRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();
        const {
            gumbo: {
                gamePk
            },
            config: {
                env,
                locale = 'en-US',
                useContentApi = false,
                context: {
                    gameContext = 'mlb'
                } = {}
            }
        } = state;

        const { name, params } = getContentDataSource(useContentApi, { gamePk, locale, gameContext, env });
        return componentDataEngine.fetchAndStore(name, params);
    };
};

export default recapDataRequestAction;
